export default __webpack_public_path__ + "static/media/logo-nav.50dab2e7.png";